export default __webpack_public_path__ + "static/media/logo_car.a56f9d9d.svg";